import '../blocks/tel/tel.js';
import '../blocks/field/field.js';
import '../blocks/select/select.js';
import '../blocks/form/form.js';
import '../blocks/lazyload/lazyload.js';
import '../blocks/partners/partners.js';
import '../blocks/news-slider/news-slider.js';
import '../blocks/gallery/gallery.js';
import '../blocks/properties-slider/properties-slider.js';
import '../blocks/popup/popup.js';
import '../blocks/header/header.js';

import '../blocks/home/home.js';
import '../blocks/about/about.js';
import '../blocks/projects/projects.js';
import '../blocks/project/project.js';
import '../blocks/catalog/catalog.js';
import '../blocks/property/property.js';
import '../blocks/news/news.js';
import '../blocks/conditions/conditions.js';

import '../blocks/svg-use-external/svg-use-external.js';
